import SortTableIcon from 'assets/icons/short-table.svg';
import { FormTitle } from 'components/Titles';
import { groupPartnerDiscounts } from 'helpers/partner.helpers';
import { ChangeSrollCss } from 'helpers/utils';
import { usePartnerAdmin } from 'hooks/usePartnersAdmin';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import {
  Box,
  Grid,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Zoom,
} from '@mui/material';

import { PartnerDiscountRow } from './partnerDiscountRow';

type IDiscount = {
  discounts?: {
    discountValue: number;
    description: string;
  }[];
  borderOrange: string;
};

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.primary.main,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.primary.main,
    maxWidth: 220,
  },
}));

const SortTableUpDownIcon = () => {
  return <Box width={25} component="img" alt="Ordenar" src={SortTableIcon} />;
};

export const PartnerDiscount: React.FC<IDiscount> = ({
  discounts,
  borderOrange,
}) => {
  const { discountsHistoric, getPartnerDiscount } = usePartnerAdmin();

  const { id } = useParams<{ id: string }>();

  const [orderDirection, setOrderDirection] = useState<'asc' | 'desc'>('desc');

  const handleSort = () => {
    setOrderDirection(orderDirection === 'asc' ? 'desc' : 'asc');
  };

  const groupedDiscounts = useMemo(() => {
    if (!discountsHistoric?.list) {
      return [];
    }

    return discountsHistoric.list.map((item) => {
      return {
        createdAt: item.createdAt,
        discounts: [...groupPartnerDiscounts(item.discounts)],
      };
    });
  }, [discountsHistoric]);

  useEffect(() => {
    getPartnerDiscount(orderDirection, id);
  }, [getPartnerDiscount, orderDirection, id]);

  return (
    <Paper
      variant="outlined"
      sx={{ border: '2px solid', borderColor: borderOrange }}
    >
      <Box p={2}>
        <Grid container alignItems="flex-start">
          <Grid item container xs={12} md={12}>
            <FormTitle title="Descontos" />
          </Grid>

          <Grid width="100%" mb={3}>
            <TableContainer
              sx={{ ...ChangeSrollCss, maxHeight: 320, minHeight: 320 }}
            >
              <Table size="small" stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell
                      component="th"
                      scope="row"
                      style={{ width: 104 }}
                    >
                      Desconto
                    </TableCell>
                    <TableCell>Descrição</TableCell>
                    <TableCell style={{ width: 160 }} onClick={handleSort}>
                      <StyledTooltip
                        arrow
                        title="Ordenar"
                        placement="right"
                        TransitionComponent={Zoom}
                        color="#FBB45F"
                      >
                        <TableSortLabel
                          active
                          direction={orderDirection}
                          IconComponent={SortTableUpDownIcon}
                        >
                          Data
                        </TableSortLabel>
                      </StyledTooltip>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {groupedDiscounts?.map((discount, index) => {
                    return <PartnerDiscountRow key={index} {...discount} />;
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          {/* <Grid item container xs={12} md={12} justifyContent="flex-end">
            <Button sx={{ paddingX: 4 }} onClick={() => alert('Edição')}>
              editar
            </Button>
          </Grid> */}
        </Grid>
      </Box>
    </Paper>
  );
};

